import { projectPolicies as policies } from 'helpers';
import Schema from './schema';


export default class Project extends Schema {

  constructor(values) {
    super(policies, values);

    this.setDtoDefinition({
      name: '',
      description: '',
      company_id: '',
      type_scm: '',
      base_url: '',
      url_scm: '',
      branch_scm: '',
      refspec_scm: '',
      credentials_id: '',
      clean: false,
      clear_update: false,
      allow_branch_override: false,
    });
  }

  setValues(data) {
    this.values = this.dtoDefinition;
    this.setDefaultValues(data);
  }
}
